<template>
  <div class="app-container">
    <el-card>
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="考场名称" prop="room_name">
          <el-input v-model="form.room_name" placeholder="请输入考场名称" />
        </el-form-item>
        <el-form-item label="考场地点" prop="room_location">
          <el-input v-model="form.room_location" placeholder="请输入考场地点" />
        </el-form-item>
        <el-form-item label="座位数" prop="room_capacity">
          <el-input-number v-model="form.room_capacity" :min="1" style="width:200px" />
        </el-form-item>
        <el-form-item label="描述" prop="room_description">
          <el-input v-model="form.room_description" placeholder="请输入描述" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" active-text="启用" inactive-text="禁用" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSubmit" :loading="saveLoading">保存</el-button>
          <el-button @click="handleCancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { addExamRoom, editExamRoom, getExamRoomDetail } from '@/api/exam'
export default {
  name: 'ExamRoomsEdit',
  data() {
    return {
      form: {
        room_name: '',
        room_location: '',
        room_capacity: 1,
        room_description: '',
        status: 1
      },
      rules: {
        room_name: [ { required: true, message: '请输入考场名称', trigger: 'blur' } ],
        room_location: [ { required: true, message: '请输入考场地点', trigger: 'blur' } ],
        room_capacity: [ { required: true, message: '请输入容量', trigger: 'blur' } ]
      },
      isEdit: false,
      saveLoading: false
    }
  },
  created() {
    if (this.$route.params.id) {
      this.isEdit = true
      this.getDetail()
    }
  },
  methods: {
    async getDetail() {
      const res = await getExamRoomDetail(this.$route.params.id)
      this.form = res.data.info
    },
    handleSubmit() {
      if (this.saveLoading) return
      this.saveLoading = true
      this.$refs.form.validate(async valid => {
        if (!valid) {
          this.saveLoading = false
          return
        }
        if (this.isEdit) {
          await editExamRoom(this.$route.params.id, this.form)
          this.$message.success('修改成功')
        } else {
          await addExamRoom(this.form)
          this.$message.success('新增成功')
        }
        this.$router.push('/exam/rooms')
        this.saveLoading = false
      })
    },
    handleCancel() {
      this.$router.push('/exam/rooms')
    }
  }
}
</script>
<style scoped>
</style> 


// WEBPACK FOOTER //
// src/views/exam/ExamRoomsEdit.vue